import React from "react";
import { Box, Dialog, Typography } from "@mui/material";

// Helper to strip HTML tags if needed
const stripHtml = (html) => {
  if (!html) return "";
  const tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
};

const ErrorDialog = ({ 
  open, 
  onClose, 
  title, 
  message, 
  showActionButton = false, 
  actionButtonText = "OK", 
  actionButtonHandler,
  actionUrl,
  showContactLink = false 
}) => {
  const handleActionClick = () => {
    if (actionUrl) {
      window.open(actionUrl, "_blank");
    }
    if (actionButtonHandler) {
      actionButtonHandler();
    }
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { width: "400px", borderRadius: "15px", maxWidth: "90vw" },
      }}
    >
      <Box sx={{ p: 3 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {title}
          </Typography>
        </Box>

        <Typography variant="body1" sx={{ mb: 3, color: "#666" }}>
          {stripHtml(message) || "An error occurred. Please try again."}
        </Typography>

        {showContactLink && (
          <a
            href="https://mail.google.com/mail/?view=cm&fs=1&to=support@chefrepublic.us"
            target="_blank"
            rel="noopener noreferrer"
            style={{ 
              color: "#FF5E41", 
              textDecoration: "underline", 
              cursor: "pointer",
              display: "block",
              mb: 2
            }}
          >
            Contact Us
          </a>
        )}

        <Box>
          <button
            onClick={handleActionClick}
            className="btn btn-orange rounded-pill"
            style={{ width: "100%" }}
          >
            {actionButtonText}
          </button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default ErrorDialog;
